<script lang="ts" setup>
import { tv } from 'tailwind-variants';
import { computed } from 'vue';
import { injectFormContext } from './Form.vue';

const formContext = injectFormContext();

const classes = computed(() => tv({
	base: 'col-span-full gap-x-4',
	variants: {
		size: {
			xs: 'gap-y-1',
			sm: 'gap-y-2',
			md: 'gap-y-6',
			lg: 'gap-y-8',
		},
	},
	defaultVariants: {
		size: 'md',
	},
})({
	size: formContext.size.value,
}));
</script>

<template>
	<DGridContainer :class="classes">
		<slot />
	</DGridContainer>
</template>
